import { Navigation, CasesContainer } from '../components/case-studies/styles'
import { Helmet } from 'react-helmet'

import { SEOCases } from '../components/case-studies/SEOCases'
import { WebCases } from '../components/case-studies/WebCases'
import { AdCases } from '../components/case-studies/AdCases'
import { SocialCases } from '../components/case-studies/SocialCases'

import * as React from 'react'
import Layout from '../components/Layout'
import Header from '../components/Header'
import { Link, graphql } from 'gatsby'

import { Box } from 'grid-styled'
import Testimonials from '../components/Testimonials'
import { testimonials } from './testimonials'
import CTA from '../components/CTA'

/* prettier-ignore */
interface IProps {
  data: {
    inf: {
      childImageSharp: {
        fluid: object
      }
    };
    bww: {
      childImageSharp: {
        fluid: object
      }
    };
    justpatios: {
      childImageSharp: {
        fluid: object
      }
    };
    soh: {
      childImageSharp: {
        fluid: object
      }
    };
  }
}

export default ({ data }: IProps) => (
  <Layout>
    {/* <Bg>
      <div>
        <div className="stripe s0" />
        <div className="stripe s1" />
        <div className="stripe s2" />
        <div className="stripe s3" />
      </div>
    </Bg> */}
    <Helmet>
      <title>Case Studies - Digital Growth Success - Turboclicks</title>
    </Helmet>
    <Header>
      <h1>You’re in good company</h1>
      <h4>Join 1000+ businesses with Turboclicks</h4>
    </Header>
    <Navigation>
      <Link to="#seo">SEO</Link>
      <Link to="#social">Social</Link>
      <Link to="#ads">Google Ads</Link>
      <Link to="#web">Web Design</Link>
      {/* <Link to="#test">Remarketing</Link> */}
    </Navigation>

    <CasesContainer>
      <WebCases image={data.inf.childImageSharp.fluid} />
      <Box mt={6} />
      <AdCases image={data.bww.childImageSharp.fluid} />
      <Box mt={6} pt={3} />
      <SEOCases image={data.justpatios.childImageSharp.fluid} />
      <Box mt={6} />
      <SocialCases image={data.soh.childImageSharp.fluid} />
      <Box mt={6} />
    </CasesContainer>

    <Box mt={5}>
      <CTA
        inverted={true}
        title="Like what you see?"
        subtitle="We’re here to help you."
        button="Contact Us"
      />
    </Box>

    <Testimonials testimonials={testimonials} />
  </Layout>
)

export const query = graphql`
  query CaseStudiesPageQuery {
    bww: file(
      relativePath: { eq: "turboclicks-brisbanewhalewatching-case.jpg" }
    ) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }

    soh: file(relativePath: { eq: "turboclicks-smartonhold-case.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }

    inf: file(
      relativePath: { eq: "turboclicks-theinflatablefactory-case.png" }
    ) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }

    justpatios: file(relativePath: { eq: "turboclicks-justpatios-case.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`
